// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"a42c3121","373":"84ef8621","682":"989f194e","832":"3e07bd3d"}[chunkId] + ".chunk.js";
};